import React, { useState } from 'react';
import { Button } from "@/components/ui/button";
import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet";
import LanguageSwitcher from "@/components/LanguageSwitcher";
import { useTranslation } from "@/hooks/useTranslation";
import { scrollToSection } from "@/utils/smoothScroll";
import { Menu, X } from "lucide-react";
import enausaLogo from "@/assets/enausa-official-logo.png";

const Header = () => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  const handleNavClick = (sectionId: string) => {
    setIsOpen(false);
    scrollToSection(sectionId);
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-background/95 backdrop-blur-sm border-b border-border shadow-soft">
      <div className="container mx-auto px-4">
        <nav className="flex items-center justify-between">
          <div className="flex items-center space-x-3">
            <img 
              src={enausaLogo} 
              alt="ENAUSA - Impulsando tu energía" 
              className="h-20 md:h-24 w-auto object-contain"
              decoding="async"
              width="137"
              height="64"
            />
          </div>
          
          <div className="flex items-center space-x-4">
            {/* Desktop Navigation */}
            <nav className="hidden md:flex items-center space-x-8">
              <button onClick={() => scrollToSection('inicio')} className="text-enausa-gray hover:text-enausa-navy transition-colors font-medium">{t('nav.home')}</button>
              <button onClick={() => scrollToSection('servicios')} className="text-enausa-gray hover:text-enausa-navy transition-colors font-medium">{t('nav.services')}</button>
              <button onClick={() => scrollToSection('nosotros')} className="text-enausa-gray hover:text-enausa-navy transition-colors font-medium">{t('nav.about')}</button>
              <a href="/empleo" className="text-enausa-gray hover:text-enausa-navy transition-colors font-medium">{t('nav.employment')}</a>
              <Button variant="enausa" size="sm" onClick={() => scrollToSection('contacto')}>
                {t('nav.contact')}
              </Button>
            </nav>
            
            {/* Language Switcher */}
            <LanguageSwitcher />
            
            {/* Mobile Menu */}
            <Sheet open={isOpen} onOpenChange={setIsOpen}>
              <SheetTrigger asChild className="md:hidden">
                <Button variant="ghost" size="icon">
                  <Menu className="h-6 w-6" />
                </Button>
              </SheetTrigger>
              <SheetContent side="right" className="w-72 bg-background">
                <div className="flex flex-col space-y-6 mt-8">
                  <div className="flex items-center justify-between mb-6">
                    <img 
                      src={enausaLogo} 
                      alt="ENAUSA" 
                      className="h-12 w-auto object-contain"
                      loading="lazy"
                      decoding="async"
                      width="137"
                      height="64"
                    />
                  </div>
                  
                   <nav className="flex flex-col space-y-4">
                     <button
                       onClick={() => handleNavClick('inicio')}
                       className="text-lg font-medium text-enausa-gray hover:text-enausa-navy transition-colors py-2 border-b border-border text-left"
                     >
                       {t('nav.home')}
                     </button>
                     <button
                       onClick={() => handleNavClick('servicios')}
                       className="text-lg font-medium text-enausa-gray hover:text-enausa-navy transition-colors py-2 border-b border-border text-left"
                     >
                       {t('nav.services')}
                     </button>
                     <button
                       onClick={() => handleNavClick('nosotros')}
                       className="text-lg font-medium text-enausa-gray hover:text-enausa-navy transition-colors py-2 border-b border-border text-left"
                     >
                       {t('nav.about')}
                     </button>
                     <a 
                       href="/empleo" 
                       onClick={() => setIsOpen(false)}
                       className="text-lg font-medium text-enausa-gray hover:text-enausa-navy transition-colors py-2 border-b border-border"
                     >
                       {t('nav.employment')}
                     </a>
                     <Button 
                       variant="enausa" 
                       size="lg" 
                       className="w-full mt-4"
                       onClick={() => handleNavClick('contacto')}
                     >
                       {t('nav.contact')}
                     </Button>
                   </nav>
                </div>
              </SheetContent>
            </Sheet>
          </div>
        </nav>
      </div>
    </header>
  );
};

export default Header;